import "./services.css";

const services = [
    {
        title: "Furniture Assembly",
        icon: "🪑",
        //description: "IKEA & all flatpack furniture, wardrobes, beds, desks with secure wall anchoring.",
        image: "/static/images/service-card-bg/furniture-assembly-bg.webp",
        items: [
                "IKEA & all flatpack", 
                "Office furniture", 
                "Wardrobes, beds & desks",
                "Secure wall anchoring"
               ],
        path: "/furniture-assembly"
    },
    {
        title: "TV Mounting & Wall Arts",
        icon: "🖼️",
        //description: "Heavy mirrors, artwork, gallery walls with secure & precise installation.",
        image: "/static/images/service-card-bg/tv-mounting-wall-art-bg.webp",
        items: [
                "TV mounting & cable management",
                "Heavy mirrors & artwork", 
                "Gallery walls", 
                "Precise alignment & levelling"
               ],
        path: "/tv-mounting-wall-art"
    },
    {
        title: "Installation Services",
        icon: "🪛",
        image: "/static/images/service-card-bg/installations-bg.webp",
        items: [
                "Curtains, blinds & tracks", 
                "Bathroom accessories",
                "Smoke alarms",
                "Basic appliances"
               ],
        path: "/installations"
    },
    {
        title: "Carpentry Services",
        icon: "🪚",
        //description: "Custom shelving, door installation, partition walls, cupboard, deck & fence repairs.",
        image: "/static/images/service-card-bg/carpentry-bg.webp",
        items: [
                "Custom shelving & storage", 
                "Door installation", 
                "Partition wall",
                "Cupboard, deck & fence repairs"
               ],
        path: "/carpentry"
    },
    {
        title: "Plastering & Painting",
        icon: "🖌️",
        //description: "Hole & crack patching, interior touch-ups, ceiling repairs and exterior painting.",
        image: "/static/images/service-card-bg/plastering-painting-bg.webp",
        items: [
                "Hole & crack patching", 
                "Interior touch-up painting", 
                "Ceiling repairs",
                "Fence & exterior painting"
               ],
        path: "/plastering-painting"
    },
    {
        title: "Home Maintenance",
        icon: "🛠️",
        //description: "Fixing doors, locks, plaster, fixtures, leaks, drawers and more.",
        image: "/static/images/service-card-bg/maintenance-bg.webp",
        items: [
                "Door & lock repairs", 
                "Minor leaks & drips", 
                "Drawer & cabinet repairs",
                "General wear & tear fixes"
               ],
        path: "/home-maintenance"
    },
    {
        title: "Commercial Maintenance",
        icon: "🏢",
        image: "/static/images/service-card-bg/commercial-maintenance-bg.webp",
        items: [
                "Office & retail repairs",
                "Fixtures, fittings & installations",
                "Assembly & minor carpentry",
                "Ongoing property upkeep"
               ],
        path: "/commercial-maintenance"
    },
    {
        title: "Outdoor & Landscaping",
        icon: "🌿",
        //description: "Garden beds, retaining walls, Colorbond fencing and timber staining.",
        image: "/static/images/service-card-bg/gardening-bg.webp",
        items: [
                "Garden beds & edging", 
                "Timber retaining walls", 
                "Colorbond fencing",
                "Timber staining & sealing"
               ],
        path: "/gardening"
    },
]

const Servicesv2 = () => {
    return (
        <div className="service">
            <div className="card-grid">
                {services.map((service, index) => (
                    <div key={index} className="card card-item">
                        <div className="card-image">
                            <img src={service.image} alt={service.title} />
                        </div>
                        <div className="card-icon-circle">
                            <span>{service.icon}</span>
                        </div>
                        <div className="card-content">
                            <h3 className="card-h3">{service.title}</h3>
                            <ul>
                                {service.items.map(item => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                            <a href={service.path} className="card-link">
                                View Details <span className="arrow">→</span>
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Servicesv2;